import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/pages/login';

import Instrument from '@/pages/instrument/instrument'
import InstrumentStatistics from '@/pages/instrument/Statistics'
import InstrumentAddition from '@/pages/instrument/Addition'
import InstrumentVerification from '@/pages/instrument/Verification'
import InstrumentAlteration from '@/pages/instrument/Alteration'
import InstrumentAudit from '@/pages/instrument/Audit'
import InstrumentEquipment from '@/pages/instrument/Equipment'
import InstrumentBorrowSituation from '@/pages/instrument/BorrowSituation'
import InstrumentInputs from '@/pages/instrument/Inputs'
import InstrumentOutputs from '@/pages/instrument/Outputs'
import InstrumentDecoration from '@/pages/instrument/Decoration'
import InstrumentCoupon from '@/pages/instrument/Coupon'
import InstrumentGenerateUri from '@/pages/instrument/GenerateUri'
import InstrumentOrders from '@/pages/instrument/Orders'
import InstrumentRefund from '@/pages/instrument/RefundReview'

import MobileShow from '@/pages/mobile/MobileShow'

import equipmentdata from '../../static/equipmentdata'

Vue.use(Router)

const router = new Router({
	routes: [
		{
		  path: '/login',
		  name: 'Login',
		  component: Login
		},
		{
		  path: '/show',
		  name: 'Show',
		  component: MobileShow
		},
    	{
	    	path: '/Instrument',
			name: 'Instrument',
			component: Instrument,
			meta: { requiresAuth: true },
			children:[
				{
					path: 'Statistics',
					name: 'InstrumentStatistics',
					component: InstrumentStatistics,
					meta: { requiresAuth: true },
				},
				{
					path: 'Addition',
					name: 'InstrumentAddition',
					component: InstrumentAddition,
					meta: { requiresAuth: true },
				},
				{
					path: 'Verification',
					name: 'InstrumentVerification',
					component: InstrumentVerification,
					meta: { requiresAuth: true },
				},
				{
					path: 'Alteration',
					name: 'InstrumentAlteration',
					component: InstrumentAlteration,
					meta: { requiresAuth: true },
				},
				{
					path: 'Audit',
					name: 'InstrumentAudit',
					component: InstrumentAudit,
					meta: { requiresAuth: true },
				},
				{
					path: 'Product',
					name: 'InstrumentEquipment',
					component: InstrumentEquipment,
					meta: { requiresAuth: true },
				},
				{
					path: 'GenerateCode',
					name: 'InstrumentBorrowSituation',
					component: InstrumentBorrowSituation,
					meta: { requiresAuth: true },
				},
				{
					path: 'Inputs',
					name: 'InstrumentInputs',
					component: InstrumentInputs,
					meta: { requiresAuth: true },
				},
				{
					path: 'Outputs',
					name: 'InstrumentOutputs',
					component: InstrumentOutputs,
					meta: { requiresAuth: true },
				},
				{
					path: 'Decoration',
					name: 'InstrumentDecoration',
					component: InstrumentDecoration,
					meta: { requiresAuth: true },
				},
        {
          path: 'GenerateCoupon',
          name: 'InstrumentCoupon',
          component: InstrumentCoupon,
          meta: { requiresAuth: true },
        },
        {
          path: 'GenerateUri',
          name: 'InstrumentGenerateUri',
          component: InstrumentGenerateUri,
          meta: { requiresAuth: true },
        },
        {
          path: 'Orders',
          name: 'InstrumentOrders',
          component: InstrumentOrders,
          meta: { requiresAuth: true },
        },
        {
          path: 'Refund',
          name: 'InstrumentRefund',
          component: InstrumentRefund,
          meta: { requiresAuth: true },
        }
			],
	    },
	]
})

// 全局前置守卫用于身份认证
router.beforeEach(async (to, from, next) => {
	if(to.matched.some(record => record.meta['requiresAuth'])){
		if(!localStorage.getItem('token')){
			next({ path: '/login' });
		}
	}
	//当未输入地址时自动重定向到login中
	if(to.path === '/'){
		next({ path: '/login' });
	}
	//当进行登录时，若是已登录则直接跳转
	if(to.path === '/login'){
		//console.log(localStorage)
		if(localStorage.getItem('token')){
			next({path: '/Instrument/Product'})
		}
	}
	next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js